import { MaxWidth } from '@advanza/ui'
import React from 'react'

const WizardStep = ({ maxWidth, component }) => <MaxWidth maxWidth={maxWidth}>{component}</MaxWidth>

export default WizardStep
